const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 460 460",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#197B68"
    },
    d: "M230,203.06h-29.375v50h-31.25v-50H85.04v-30H120V133.1h30v39.96h109.375v50h31.25v-50h84.335v-30 H340V103.1h-30v39.96h-80v-36h-49.96v-30H230V0c-23.02,0-42.99,12.97-53.06,31.99c-18.22-11.44-42.01-12.68-61.94-1.18 C95.07,42.32,84.25,63.54,85.04,85.04C63.54,84.25,42.32,95.07,30.81,115c-11.5,19.93-10.26,43.72,1.18,61.94 C12.97,187.01,0,206.98,0,230s12.97,42.99,31.99,53.06H230V203.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004A3C"
    },
    d: "M428.01,176.94c11.44-18.22,12.68-42.01,1.18-61.94c-11.51-19.93-32.73-30.75-54.23-29.96 c0.79-21.5-10.03-42.72-29.96-54.23c-19.93-11.5-43.72-10.26-61.94,1.18C272.99,12.97,253.02,0,230,0v77.06h50.04v30H230v36h80 V103.1h30v39.96h34.96v30h-84.335v50h-31.25v-50H230v110h198.01C447.03,272.99,460,253.02,460,230S447.03,187.01,428.01,176.94z  M393.51,253.06h-30v-30h30V253.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#206A5C"
    },
    d: "M329.01,283.06h-99c0,47.828,33.909,87.729,79,96.979V460h40v-79.961 c-6.459,1.325-13.148,2.021-20,2.021V283.06z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.04,
    y: 77.06,
    style: {
      fill: "#004A3C"
    },
    width: 50,
    height: 30
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#004A3C"
    },
    points: "150,133.1 120,133.1 120,173.06 85.04,173.06 85.04,203.06 169.375,203.06 169.375,253.06 200.625,253.06 200.625,203.06 230,203.06 230,173.06 150,173.06  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.04,
    y: 77.06,
    style: {
      fill: "#318B79"
    },
    width: 50,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.51,
    y: 223.06,
    style: {
      fill: "#197B68"
    },
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#318B79"
    },
    d: "M329.01,382.06c6.852,0,13.54-0.697,20-2.021c45.091-9.249,79-49.15,79-96.979h-99V382.06z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.971b89ef1867da1c26c5b032870e0bc1.svg";
export { ForwardRef as ReactComponent };